import marina from '../../assets/createAccountPage/marina.png';
import alana from '../../assets/createAccountPage/alana.png';
import eila from '../../assets/createAccountPage/eila.png';
import frankie from '../../assets/createAccountPage/frankie.png';
import isabella from '../../assets/createAccountPage/isabella.png';
import laura from '../../assets/createAccountPage/laura.png';
import louise from '../../assets/createAccountPage/louise.png';
import madison from '../../assets/createAccountPage/madison.png';
import shannon from '../../assets/createAccountPage/shannon.png';
import tia from '../../assets/createAccountPage/tia.png';
import whitney from '../../assets/createAccountPage/whitney.png';
import cecelia from '../../assets/createAccountPage/Cecelia.png';
import veronica from '../../assets/createAccountPage/Veronica.png';
import hanna from '../../assets/createAccountPage/Hanna.png';
import jaime from '../../assets/createAccountPage/Jaime.png';
import taylor from '../../assets/createAccountPage/Taylor.png';
import emma from '../../assets/createAccountPage/Emma.png';


const createAccountImages = [
  { id: '71', anchorImage: marina },
  { id: '104', anchorImage: alana },
  { id: '64', anchorImage: eila },
  { id: '114', anchorImage: frankie },
  { id: '72', anchorImage: isabella },
  { id: '105', anchorImage: laura },
  { id: '238', anchorImage: louise },
  { id: '79', anchorImage: madison },
  { id: '100', anchorImage: shannon },
  { id: '107', anchorImage: tia },
  { id: '58', anchorImage: whitney },
  { id: '244', anchorImage: cecelia },
  { id: '246', anchorImage: veronica },
  { id: '1277', anchorImage: hanna },
  { id: '14925', anchorImage: jaime },
  { id: '1474', anchorImage: taylor },
  { id: '28040', anchorImage: emma },
];

export const getRandomImage = () => {
  const randomIndex = Math.floor(Math.random() * createAccountImages.length);

  return createAccountImages[randomIndex];
};

export const getAnchorImage = (id) => {
  const anchorImage = createAccountImages.filter((image) => image.id === id);

  if (anchorImage.length === 0) {
    return getRandomImage();
  }

  return anchorImage[0];
};

